import ky, { type BeforeErrorHook, type BeforeRequestHook, type KyInstance } from "ky";
import { userCache } from "@/shared-utils/auth";
import { env } from "../environment";
import type { EvaluationResultsErrorResponse, TranscriptContent } from "./types";

export class EvaluationApiClient {
    private api: KyInstance;

    constructor() {
        this.api = ky.create({
            prefixUrl: env.expertUniversityEvaluationApiUrl,
            timeout: 30_000,
            hooks: {
                beforeRequest: [this.createAuthorizationBearerHook(() => userCache.ssoAccessToken)],
                beforeError: [this.createErrorLoggingHook()],
            },
        });
    }

    triggerEvaluationBySessionId = async (
        sessionId: string,
    ): Promise<TranscriptContent | EvaluationResultsErrorResponse> => {
        const response = await this.api.post(`ai-roleplay-evaluations`, {
            json: {
                session_id: sessionId,
                source: "exwo",
            },
        });

        return response.json<TranscriptContent | EvaluationResultsErrorResponse>();
    };

    private createAuthorizationBearerHook(tokenProvider: () => string | undefined): BeforeRequestHook {
        return ({ headers }) => {
            if (headers.has("Authorization")) return;
            const accessToken = tokenProvider();
            if (!accessToken) {
                throw new Error("Access token doesn’t exist");
            }
            headers.set("Authorization", `Bearer ${accessToken}`);
        };
    }

    private createErrorLoggingHook(): BeforeErrorHook {
        return (error) => {
            const {
                request: { method, url },
                response: { status, statusText },
            } = error;
            console.log({ method, url, status, statusText }, "received an HTTP Error");
            return error;
        };
    }
}
